import styled from '@emotion/styled';
export const Container = styled.div`
  position: relative;
`;
export const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const CurriculumPanel = styled.div`
  flex: 1;
  background-color: transparent;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  max-width: none;
  width: 100%;
  display: ${(props)=>props.$isHidden ? 'none' : 'block'};
  position: relative;
  border: ${(props)=>props.$isDragActive ? '2px dashed #2563eb' : 'none'};
  background-color: ${(props)=>props.$isDragActive ? 'rgba(37, 99, 235, 0.04)' : 'transparent'};
  
  @media (max-width: 1024px) {
    padding: 0;
  }
`;
export const EditorPanel = styled.div`
  flex: ${(props)=>props.$isFullWidth ? '1' : '2'};
  background-color: transparent;
  border-radius: 0;
  box-shadow: none;
  min-height: 600px;
  width: ${(props)=>props.$isFullWidth ? '100%' : 'auto'};
  position: relative;
`;
export const TabsBar = styled.div`
  display: inline-flex;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
  margin-bottom: 16px;
`;
export const TabButton = styled.button`
  padding: 8px 16px;
  font-size: 0.9rem;
  border: none;
  background-color: ${(props)=>props.$active ? '#1d4ed8' : 'transparent'};
  color: ${(props)=>props.$active ? '#ffffff' : '#4b5563'};
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:not(:last-of-type) {
    border-right: 1px solid #e5e7eb;
  }

  &:hover {
    background-color: ${(props)=>props.$active ? '#1d4ed8' : '#f3f4f6'};
  }
`;
export const BackToMenuButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 0 12px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.875rem;
  color: #374151;
  
  &:hover {
    background-color: #f3f4f6;
  }
`;
export const LanguageToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;
export const LanguageSelectGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
`;
export const LanguageSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
`;
export const LanguageLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
`;
export const LanguageStaticValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;
  color: #1f2937;
  font-weight: 500;
`;
export const LanguageActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
`;
export const LanguageHelper = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
`;
export const SectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const SectionItem = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
  box-shadow: ${(props)=>props.$isDragging ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'};
`;
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
`;
export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
`;
export const SectionActions = styled.div`
  display: flex;
  gap: 8px;
`;
export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  color: #6b7280;
  
  &:hover {
    background-color: #f3f4f6;
    color: #1f2937;
  }
`;
export const LessonList = styled.div`
  padding: 8px 0;
`;
export const LessonItem = styled.div`
  padding: 8px 16px 8px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${(props)=>props.$isSelected ? '#eff6ff' : 'transparent'};
  border-left: 3px solid ${(props)=>props.$isSelected ? '#2563eb' : 'transparent'};
  box-shadow: ${(props)=>props.$isDragging ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none'};
  
  &:hover [data-lesson-actions="true"] {
    opacity: 1;
  }
  
  &:hover {
    background-color: ${(props)=>props.$isSelected ? '#eff6ff' : '#f9fafb'};
  }
`;
export const LessonTitle = styled.span`
  font-size: 0.875rem;
  color: #4b5563;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const LessonActions = styled.div`
  display: flex;
  gap: 4px;
  opacity: 0.5;
  transition: opacity 0.2s;
`;
export const DropOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(37, 99, 235, 0.1);
  color: #1d4ed8;
  font-weight: 600;
  font-size: 0.95rem;
  pointer-events: none;
  text-align: center;
  padding: 0 16px;
`;
export const AddItemForm = styled.form`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 16px;
`;
export const InputField = styled.input`
  flex-grow: 1;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.875rem;
  
  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
  }
`;
export const EmptyEditor = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  color: #6b7280;
  text-align: center;
`;
export const DragHandle = styled.div`
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #9ca3af;
  margin-right: 8px;
  
  &:active {
    cursor: grabbing;
  }
`;
export const MarkdownActionButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;
export const HiddenFileInput = styled.input`
  display: none;
`;
